const PERMISSION_KEY= "company:company";
const PAGE_URL = {
    COMPANY_PAGE: "/admin/company/company"
}

export {PERMISSION_KEY, PAGE_URL}

